import { useTranslation } from 'react-i18next';
import { Control, Path } from 'react-hook-form';

import { Stack } from '@mui/material';

import Typography from '../../../../../../../../../components/Typography';
import { AttendanceData } from '../../../../../../../../../db/classes/types';
import { i18nNS } from '../../../../../../../../../i18n';
import ClassList from '../ClassList';
import { FormValues } from '../types';

export interface InSessionAttendanceProps<T extends FormValues> {
  inSessionAttendanceData: AttendanceData['inSession'];
  control: Control<T>;
  name: Path<T>;
}

const InSessionAttendance = <T extends FormValues>({
  inSessionAttendanceData,
  control,
  name,
}: InSessionAttendanceProps<T>) => {
  const { t } = useTranslation([i18nNS.SHARED, i18nNS.CLASS]);

  return (
    <Stack gap={2}>
      <Typography variant="paragraphBold" component="h3">
        {t('select_the_lecture', { ns: i18nNS.CLASS })}
      </Typography>
      <Typography variant="paragraphRegular">
        {t(
          'these_are_the_relevant_scheduled_lectures_in_your_courses_that_are_currently_in_session_and_availble_for_recording_attendance',
          { ns: i18nNS.CLASS }
        )}
      </Typography>
      {inSessionAttendanceData.map(({ courseData, classData }) => {
        return (
          <Stack gap={2}>
            <Typography
              variant="paragraphBold"
              color="grey.600"
              px={2}
              pb={1}
              position="sticky"
              top={0}
              zIndex={1}
              bgcolor="white"
            >
              {t('course_code_colon_course_title', {
                ns: i18nNS.SHARED,
                courseCode: courseData.code,
                courseTitle: courseData.title,
              })}
            </Typography>
            <ClassList control={control} name={name} isLoading={false} classList={classData} />
          </Stack>
        );
      })}
    </Stack>
  );
};

export default InSessionAttendance;
